export default "__VITE_ASSET__CceBU2QU__"